import { createContext, useState, useContext, useCallback, useMemo } from 'react';

import { defaultPeriod, presetRange } from '../helpers/period';

export const CurrentPeriodContext = createContext();

export const useCurrentPeriod = () => useContext(CurrentPeriodContext);

export const CurrentPeriodProvider = ({ children }) => {
  const [period, setPeriodState] = useState(defaultPeriod);

  const setPeriod = useCallback(({ start, end }) => {
    setPeriodState((current) => ({ start: start ?? current.start, end: end ?? current.end }));
  }, []);

  const setPreset = useCallback((key) => {
    const range = presetRange(key);

    if (range) {
      setPeriodState(range);
    }
  }, []);

  const value = useMemo(() => ({
    start: period.start,
    end: period.end,
    setStart: (start) => setPeriod({ start }),
    setEnd: (end) => setPeriod({ end }),
    setPeriod,
    setPreset,
  }), [period, setPeriod, setPreset]);

  return (
    <CurrentPeriodContext.Provider value={value}>
      {children}
    </CurrentPeriodContext.Provider>
  );
};
